import{
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
} from '../types'

export const logInReducer = (state={},action) =>{
    switch(action.type){
        case LOGIN_REQUEST:
            return{
                processing:true,
            }

        case LOGIN_SUCCESS:
            return{
                processing:false,
                userInfo:action.payload
            }

        case LOGIN_FAIL:
            return{
                processing:false,
                error:action.payload
            }
        case LOGOUT:
            return {}
        default:
            return state
    }
}

export const logOutReducer = (state={},action) =>{
    switch(action.type){
        case LOGOUT_REQUEST:
            return{
                processing:true,
                userauth:null,
                error: false
            }

        case LOGOUT_SUCCESS:
            return{
                processing:false,
                userauth:action.payload,
                error: false
            }
        case LOGOUT_FAIL:
            return{
                processing:false,
                userauth: null,
                error:action.payload
            }
        default:
            return state
    }
}
